import { Injectable, NgZone } from '@angular/core';
import { OAuthStorage } from 'angular-oauth2-oidc';

@Injectable()
export class NoOpStorageService implements OAuthStorage {

  constructor() {
    
  }

  public getItem(key: string): string | null {
    return null;
  }

  public removeItem(key: string): void {
    return null;
  }

  public setItem(key: string, data: string): void {
    return null;
  }
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/user/noop-storage-service.ts